import apiService from '@/api/apiService';

export const createUserDetailVersion = async (payload) => {
    const url = '/api/admin/user-detail-version';
    return apiService.POST(url, payload);
};